import React, { useState } from "react";
import {
  Tab,
  Nav,
  Row,
  Col,
  Button,
  InputGroup,
  Form,
  Modal,
} from "react-bootstrap";
import { FaCalendarAlt, FaBell, FaCircle } from "react-icons/fa";
import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";
import "./NotificationComponent.css";
import TitleComponent from "../TitleComponent/TitleComponent";

const NotificationComponent = () => {
  const [activeTab, setActiveTab] = useState("incoming");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showSendNotification, setShowSendNotification] = useState(false);
  const [visibleButtons, setVisibleButtons] = useState(null);
  const [message, setMessage] = useState("");

  // Mock data for incoming notifications
  const notifications = [
    {
      id: 1,
      user: "John Doe",
      text: "New order received",
      time: "20 mins ago",
      isAccountDeletion: false,
      unseen: true,
    },
    {
      id: 2,
      user: "Jane Smith",
      text: "Request to delete account",
      time: "1 hour ago",
      isAccountDeletion: true,
      unseen: true,
    },
    {
      id: 3,
      user: "Bob Brown",
      text: "Order marked as complete",
      time: "2 hours ago",
      isAccountDeletion: false,
      unseen: false,
    },
  ];

  // Mock data for outgoing notifications
  const outgoingNotifications = [
    {
      id: 1,
      user: "Admin",
      text: "Notification sent to all users",
      time: "5 mins ago",
    },
    {
      id: 2,
      user: "Admin",
      text: "Important update on services",
      time: "30 mins ago",
    },
    { id: 3, user: "Admin", text: "New promotional offer", time: "1 hour ago" },
  ];

  const handleCalendarClick = () => setShowCalendar(!showCalendar);
  const handleSendNotification = () => setShowSendNotification(true);
  const handleCloseSendNotification = () => setShowSendNotification(false);

  const handleDeleteClick = (id) =>{
    // console.log(`Deleting account for notification ID ${id}`);
  }
  const handleRejectClick = (id) =>{
    // console.log(`Rejecting account deletion request for notification ID ${id}`);
  }
  const notificationTitle = `Notifications (${notifications.length})`;

  // Custom toolbar options (similar to what you provided in the image)
  const quillModules = {
    toolbar: [
      [{ size: ["10px", "12px", "14px", "18px", "24px", "36px", "48px"] }],
      ["color", "bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  return (
    <div className="notifications-component">
      <Row className="mb-3 notification-header">
        <Col xs={6} className="notification-title">
          <TitleComponent title={notificationTitle} />
        </Col>
        <Col
          xs={6}
          className="text-end d-flex align-items-center notification-actions"
        >
          <div className="input-container" style={{ flex: 1, maxWidth: "58%" }}>
            <InputGroup className="me-2">
              <Form.Control type="text" placeholder="Search notifications..." />
              <InputGroup.Text onClick={handleCalendarClick}>
                <FaCalendarAlt />
              </InputGroup.Text>
            </InputGroup>
            {showCalendar && (
              <div className="calendar-popup">
                {" "}
                {/* Calendar logic here */}{" "}
              </div>
            )}
          </div>

          <div
            className="button-container"
            style={{ flex: 1, maxWidth: "42%" }}
          >
            <Button className="button" onClick={handleSendNotification}>
              <FaBell className="me-2" /> Send Notification
            </Button>
          </div>
        </Col>
      </Row>

      <Tab.Container
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
      >
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="incoming">Incoming</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="outgoing">Outgoing</Nav.Link>
          </Nav.Item>
        </Nav>
        <hr />
        <Tab.Content>
          {/* Incoming Tab */}
          <Tab.Pane eventKey="incoming">
            {notifications.map((notification) => (
              <Row
                key={notification.id}
                className="align-items-center notification-item"
              >
                <Col xs={1}>
                  <div className="user-icon">{notification.user.charAt(0)}</div>
                </Col>
                <Col xs={8}>
                  <p className="notification-text">
                    {notification.isAccountDeletion ? (
                      <span className="user">{notification.user}</span>
                    ) : (
                      notification.user
                    )}{" "}
                    {notification.text}
                    <br />
                    <span className="notification-time">
                      {notification.time}
                    </span>
                  </p>
                </Col>
                <Col xs={3} className="text-end position-relative">
                  {notification.unseen && <FaCircle className="dot-icon" />}
                  {notification.isAccountDeletion && (
                    <div className="action-buttons">
                      <Button
                        className="button delete-button me-2"
                        onClick={() => handleDeleteClick(notification.id)}
                      >
                        Delete
                      </Button>
                      <Button
                        className="button reject-button"
                        onClick={() => handleRejectClick(notification.id)}
                      >
                        Reject
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
            ))}
          </Tab.Pane>

          {/* Outgoing Tab */}
          <Tab.Pane eventKey="outgoing">
            {outgoingNotifications.length > 0 ? (
              outgoingNotifications.map((notification) => (
                <Row
                  key={notification.id}
                  className="align-items-center notification-item"
                >
                  <Col xs={1}>
                    <div className="user-icon">
                      {notification.user.charAt(0)}
                    </div>
                  </Col>
                  <Col xs={8}>
                    <p className="notification-text">
                      {notification.user} {notification.text}
                      <br />
                      <span className="notification-time">
                        {notification.time}
                      </span>
                    </p>
                  </Col>
                  <Col xs={3} className="text-end">
                    {/* <Button className="button" disabled>Sent</Button> */}
                    <FaCircle className="dot-icon" />
                  </Col>
                </Row>
              ))
            ) : (
              <p>No outgoing notifications.</p>
            )}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>

      {/* Send Notification Modal */}
      <Modal
        className="modal-container custom-modal-width notificationModeler"
        show={showSendNotification}
        onHide={handleCloseSendNotification}
      >
        <Modal.Header closeButton>
          <Modal.Title>Send Notification(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="recipientCategory" className="my-2">
              <Form.Label>Recipient Category</Form.Label>
              <Form.Control as="select" className="form-select">
                <option disabled selected>
                  Select Category of user
                </option>
                <option>Farmers</option>
                <option>Suppliers</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="recipient" className="my-2">
              <Form.Label>Recipient</Form.Label>
              <Form.Control as="select" className="form-select">
                <option disabled selected>
                  Select Recipient
                </option>
                <option>User 1</option>
                <option>User 2</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="notificationText" className="my-2">
              <Form.Label>Message</Form.Label>
              <ReactQuill
                modules={quillModules}
                theme="snow"
                className="message-box"
              />
            </Form.Group>

            <Form.Group className="text-center mt-5">
              <Button type="submit" className="button buttoner">
                Send Notification
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NotificationComponent;
